module.exports = __webpack_public_path__ + "img/plus-circle-solid.4d6d1544.svg";